import React, {useEffect, useState} from 'react';
// import { Spinner } from "react-activity";
import Spinner from "react-activity/dist/Spinner";
import "react-activity/dist/Spinner.css";
import axios from 'axios';
import { apiUrl } from '../../config/Config';
import { useNavigate } from 'react-router-dom';
import { Alert } from 'bootstrap';
// import { useDispatch, useSelector } from "react-redux/es/exports";
import { useDispatch, useSelector } from 'react-redux';
// import chlogo from '../assets/images/htnewlogo1.webp';
import logo from '../../assets/images/srlogo.jpeg';
import Swal from 'sweetalert2';
import tanuragalogo from '../../assets/images/tanuraga-logo.png';


const Login = () => {
    const [username, setusername] = useState(null);
    const [password, setpassword] = useState();
    const [showloding, setshowloding] = useState(false);
    const [token, settoken] = useState(null);
    const [showpasswordview, setshowpasswordview] = useState(false);
    // console.log('userdata >>', userdata);
    let navigate = useNavigate();
    const dispatch = useDispatch(); 
    const userdata = useSelector((store) => store.userReducer.userdata);
    
    const loginpressed = async() => {
      // navigate('/customer/home');
      if(username && password) {
        setshowloding(true);
        var data = {
            'username' : username,
            'password': password
        }
        const headers = {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*'
            }
        }
        let resp = await axios.post(apiUrl + 'adminlogin', data, headers).then((res) => {
            if(res.data.status == 'success') {
              dispatch({ type: "userdata", payload: res.data.data })
              navigate('/admin/dashboard');
            } else {
              Swal.fire({
                title: '',
                text: res.data.message,
                icon: 'error',
                customClass: {
                  icon: 'custom-swal-icon' // Apply the custom class
                },
                width: '350px',
                confirmButtonText: 'Ok',
            confirmButtonColor: "rgb(59, 151, 196)",
                customClass: {
                    popup: "small-icon-alert",
                  },
              });
              
            }
        } ).catch((err) => {
            alert(err.message)
        })
        setshowloding(false);
    } else {
        Swal.fire({
          title: '',
          text: 'username and password is required',
          icon: 'error',
          customClass: {
            icon: 'custom-swal-icon' // Apply the custom class
          },
          width: '350px',
          confirmButtonText: 'Ok',
      confirmButtonColor: "rgb(59, 151, 196)",
          customClass: {
              popup: "small-icon-alert",
            },
        });
    }
    }  

    // const handleFBLogin = () => {
    //   window.FB.login(
    //     function (response) {
    //       if (response.authResponse) {
    //         const accessToken = response.authResponse.accessToken;
    //         console.log("Access Token:", accessToken);
    
    //         // You can now use this token to call Graph API
    //       } else {
    //         console.log("User cancelled login or did not authorize.");
    //       }
    //     },
    //     { scope: "pages_show_list,pages_read_engagement,public_profile,email" } // add scopes as needed
    //   );
    // }

    useEffect(() => {
        if (userdata && Object.keys(userdata).length > 0) {
            //   fetchdata();
            // navigate("/users");
          } else {
          }
    }, [])

    // useEffect(() => {
    //   // 1. Load Facebook SDK Script
    //   const loadFacebookSDK = () => {
    //     if (document.getElementById("facebook-jssdk")) return;
  
    //     const script = document.createElement("script");
    //     script.id = "facebook-jssdk";
    //     script.src = "https://connect.facebook.net/en_US/all.js";
    //     script.async = true;
    //     script.defer = true;
    //     document.body.appendChild(script);
  
    //     window.fbAsyncInit = function () {
    //       window.FB.init({
    //         appId: "1377138816855314",
    //         cookie: true,
    //         xfbml: true,
    //         version: "v23.0",
    //       });
  
    //       console.log("Facebook SDK Initialized");
    //     };
    //   };
  
    //   loadFacebookSDK();
    // }, []);

   

    return (
      <div className="loginBoxMaindiv">
        <div className="loginBox webloginBox">
        <img src={tanuragalogo} />
        <div className="mb-3 mt-4">
          <label for="email" className="form-label">
            Email:
          </label>
          <input
            type="text"
            value={username} onChange={(t) => {setusername(t.target.value)}}
            className="form-control logininput"
            placeholder="Enter Email"
          />
        </div>
        <div className="mb-4">
          <label for="pwd" className="form-label">
            Password:
          </label>
          <input
            type="password"
            value={password} onChange={(t) => {setpassword(t.target.value)}}
            className="form-control logininput"
            id="pwd"
            placeholder="Enter password"
            name="pswd"
          />
        </div>
        <div className='mb-2'>
            <button type="button" className="btn btn-primary webcustom-btn"  onClick={() => {loginpressed()}}>
                {showloding ?
                <Spinner color='#fff' size={15} className='spinnerCenter' /> : 'LOGIN'
            }
            </button>

            {/* <button type="button" className="btn btn-primary webcustom-btn"  onClick={() => {handleFBLogin()}}>
                Log in with facebook
            </button> */}
        </div>
        
        
      </div>
      </div>
      
    );
}

export default Login;